<template>
  <div v-if="showPageInfo" class="flex flex-wrap page-info">
    <VIcon
      v-if="!!author"
      icon="i-tabler-user"
      :text="author"
      class="page-info__icon"
    />

    <VIcon
      v-if="!!date"
      icon="i-tabler-calendar"
      :text="date"
      class="page-info__icon"
    />

    <VIcon
      v-if="!!categories && categories.length > 0"
      icon="i-tabler-folder"
      class="page-info__icon"
    >
      <a class="hover:text-primary mr-1" v-for="category in categories" :href="`/category.html?key=${category}&page=1`">{{ category }}</a>
    </VIcon>

    <VIcon
      v-if="!!tags && tags.length > 0"
      icon="i-tabler-tag"
      class="page-info__icon"
    >
      <a class="hover:text-primary mr-1" v-for="tag in tags" :href="`/tag.html?key=${tag}&page=1`">{{ tag }}</a>
    </VIcon>

    <VIcon icon="i-tabler-eye" v-if="showValineViews || showWalineViews">
      <!-- <ValineViews v-if="showValineViews" /> -->
      <WalineView v-if="showWalineViews" :path="pageData.url" />
    </VIcon>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import { useData } from 'vitepress'
import dayjs from 'dayjs'
import { useCommentConfig } from '../composables/useCommentConfig'
import WalineView from './comments/WalineView.vue'

interface Props {
  pageData: Record<string, any>
  hideView?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  pageData: () => ({}),
  hideView: false,
});
const { pageData, hideView } = toRefs(props)
const { type, options } = useCommentConfig()
const { theme } = useData();
const author = computed(
  () => pageData?.value?.frontmatter?.author || theme.value.author || ''
);

const date = computed(() => {
  const d = pageData?.value?.frontmatter?.date
  return d ? dayjs(d).format('YYYY-MM-DD') : ''
});

const categories = computed(
  () => pageData?.value?.frontmatter?.categories || []
);

const tags = computed(() => pageData?.value?.frontmatter?.tags || []);

const showPageInfo = computed(
  () =>
    !!author.value ||
    !!date.value ||
    !!(categories.value && categories.value.length > 0) ||
    !!(tags.value && tags.value.length > 0)
);

const showValineViews = computed(() => {
  return (
    type.value === 'valine' && options.value.visitor != false && !hideView.value
  );
});

const showWalineViews = computed(() => {
  return (
    type.value === 'waline' &&
    options.value.pageview != false &&
    !hideView.value
  );
});
</script>

<style>
.page-info__icon {
  &:not(:last-child) {
    @apply mr-5;
  }
  a:not(:last-child) {
    @apply mr-2;
  }
}
</style>
